/**
 * ONE shared ledger-direction convention, used everywhere a net/balance is
 * shown (overview, per-party ledger, transaction detail): the underlying math
 * is dr − cr, and
 *   POSITIVE  = amount RECEIVABLE BY you (the party owes you; you are creditor)
 *   NEGATIVE  = amount PAYABLE BY you (you owe the party)
 * Never present the reverse sign anywhere. Colour: receivable green, payable
 * red, settled (exactly zero) muted.
 */

export function directionLabel(value: number): "Receivable" | "Payable" | "Settled" {
  if (value > 0) return "Receivable";
  if (value < 0) return "Payable";
  return "Settled";
}

export function netColor(value: number): string {
  if (value > 0) return "var(--success)";
  if (value < 0) return "var(--danger)";
  return "var(--text-muted)";
}

/** Small pill stating the direction of a net/balance under the shared convention. */
export function NetTag({ value }: { value: number }) {
  const label = directionLabel(value);
  return <span className={`badge ${label.toLowerCase()}`}>{label}</span>;
}
